/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CtmsItemRespVo } from './CtmsItemRespVo';
import {
    CtmsItemRespVoFromJSON,
    CtmsItemRespVoFromJSONTyped,
    CtmsItemRespVoToJSON,
    CtmsItemRespVoToJSONTyped,
} from './CtmsItemRespVo';

/**
 * 
 * @export
 * @interface PageDataCtmsItemRespVo
 */
export interface PageDataCtmsItemRespVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCtmsItemRespVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCtmsItemRespVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCtmsItemRespVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CtmsItemRespVo>}
     * @memberof PageDataCtmsItemRespVo
     */
    records?: Array<CtmsItemRespVo>;
}

/**
 * Check if a given object implements the PageDataCtmsItemRespVo interface.
 */
export function instanceOfPageDataCtmsItemRespVo(value: object): value is PageDataCtmsItemRespVo {
    return true;
}

export function PageDataCtmsItemRespVoFromJSON(json: any): PageDataCtmsItemRespVo {
    return PageDataCtmsItemRespVoFromJSONTyped(json, false);
}

export function PageDataCtmsItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCtmsItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CtmsItemRespVoFromJSON)),
    };
}

export function PageDataCtmsItemRespVoToJSON(json: any): PageDataCtmsItemRespVo {
    return PageDataCtmsItemRespVoToJSONTyped(json, false);
}

export function PageDataCtmsItemRespVoToJSONTyped(value?: PageDataCtmsItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CtmsItemRespVoToJSON)),
    };
}

